import { defineNuxtPlugin } from '#app'

import { LocalGrouperIntegrationType } from '@grouper/modules/integrations/localGrouper/integrationTypes'
import { SMTPIntegrationType } from '@grouper/modules/integrations/core/integrationTypes'
import { AIIntegrationType } from '@grouper/modules/integrations/ai/integrationTypes'
import {
  LocalGrouperGetRowServiceType,
  LocalGrouperListRowsServiceType,
  LocalGrouperAggregateRowsServiceType,
  LocalGrouperCreateRowsWorkflowServiceType,
  LocalGrouperCreateRowWorkflowServiceType,
  LocalGrouperDeleteRowWorkflowServiceType,
  LocalGrouperUpdateRowWorkflowServiceType,
  LocalGrouperUpdateRowsWorkflowServiceType,
  LocalGrouperRowsCreatedTriggerServiceType,
  LocalGrouperRowsUpdatedTriggerServiceType,
  LocalGrouperRowsDeletedTriggerServiceType,
  LocalGrouperFieldsUpdatedTriggerServiceType,
} from '@grouper/modules/integrations/localGrouper/serviceTypes'
import {
  CoreCSVFileReaderServiceType,
  CoreHTTPRequestServiceType,
  PeriodicTriggerServiceType,
  CoreRouterServiceType,
  CoreGotoServiceType,
  CoreSMTPEmailServiceType,
  CoreHTTPTriggerServiceType,
  CoreIteratorServiceType,
  CoreStartWorkflowServiceType,
  CoreManualTriggerServiceType,
} from '@grouper/modules/integrations/core/serviceTypes'
import { AIAgentServiceType } from '@grouper/modules/integrations/ai/serviceTypes'
import { SlackWriteMessageServiceType } from '@grouper/modules/integrations/slack/serviceTypes'
import { SlackBotIntegrationType } from '@grouper/modules/integrations/slack/integrationTypes'

export default defineNuxtPlugin({
  dependsOn: ['core'],
  setup(nuxtApp) {
    const { $registry } = nuxtApp

    const context = { app: nuxtApp }

    $registry.register('integration', new LocalGrouperIntegrationType(context))
    $registry.register('integration', new SMTPIntegrationType(context))
    $registry.register('integration', new AIIntegrationType(context))
    $registry.register('integration', new SlackBotIntegrationType(context))

    $registry.register('service', new LocalGrouperGetRowServiceType(context))
    $registry.register('service', new LocalGrouperListRowsServiceType(context))
    $registry.register(
      'service',
      new LocalGrouperAggregateRowsServiceType(context)
    )
    $registry.register(
      'service',
      new LocalGrouperCreateRowWorkflowServiceType(context)
    )
    $registry.register(
      'service',
      new LocalGrouperCreateRowsWorkflowServiceType(context)
    )
    $registry.register(
      'service',
      new LocalGrouperUpdateRowWorkflowServiceType(context)
    )
    $registry.register(
      'service',
      new LocalGrouperUpdateRowsWorkflowServiceType(context)
    )
    $registry.register(
      'service',
      new LocalGrouperDeleteRowWorkflowServiceType(context)
    )
    $registry.register('service', new CoreHTTPRequestServiceType(context))
    $registry.register('service', new CoreSMTPEmailServiceType(context))
    $registry.register('service', new CoreRouterServiceType(context))
    $registry.register('service', new CoreGotoServiceType(context))
    $registry.register('service', new CoreHTTPTriggerServiceType(context))
    $registry.register('service', new CoreManualTriggerServiceType(context))
    $registry.register('service', new CoreIteratorServiceType(context))
    $registry.register('service', new CoreCSVFileReaderServiceType(context))
    $registry.register('service', new CoreStartWorkflowServiceType(context))
    $registry.register('service', new AIAgentServiceType(context))
    $registry.register('service', new PeriodicTriggerServiceType(context))
    $registry.register('service', new SlackWriteMessageServiceType(context))
    $registry.register(
      'service',
      new LocalGrouperRowsCreatedTriggerServiceType(context)
    )
    $registry.register(
      'service',
      new LocalGrouperRowsUpdatedTriggerServiceType(context)
    )
    $registry.register(
      'service',
      new LocalGrouperRowsDeletedTriggerServiceType(context)
    )
    $registry.register(
      'service',
      new LocalGrouperFieldsUpdatedTriggerServiceType(context)
    )
  },
})
